import {v4 as uuid} from "uuid";

/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    // 3 MUSIC
    _id: uuid(),
    title: 'Dua Lipa - Levitating Featuring DaBaby (Official Music Video)',
    description: "The official music video for Dua Lipa - Levitating featuring @DaBaby \n\nTaken from her second studio album 'Future Nostalgia' released in 2020, which featured the hit singles 'Don't Start Now', 'Physical', 'Break My Heart'",
    creator: 'Dua Lipa',
    logo: 'https://yt3.ggpht.com/ytc/AKedOLRjI68131sY_h0hUZkGgxqMDlKe-IosbR65zo476A=s88-c-k-c0x00ffffff-no-rj-mo',
    thumbnail: 'https://i.ytimg.com/vi/TUVcZfQe-Kw/mqdefault.jpg',
    views: '110k',
    createdAt: '12 May 2022',
    src: 'https://www.youtube.com/embed/PumNp_O_Euo',
    category: 'music',
    duration: '5:58',
  },
  {
    // 3 MUSIC
    _id: uuid(),
    title: "Coke Studio | Season 14 | Pasoori | Ali Sethi x Shae Gill",
    description: "Let’s transcend boundaries and bridge distances through compassion, love and identity.\n#Pasoori #RealMagic #CokeStudioSeason14 #SoundOfTheNation\n\nListen on Spotify: https://spoti.fi/3HxDfgw\n\n\nCoke Studio 14\nCurate",
    creator: 'Coke Studio',
    logo: "https://yt3.ggpht.com/ytc/AKedOLRGa6COc1NMZToRC7R86s1PId85YlELWASKQxx2lw=s88-c-k-c0x00ffffff-no-rj",
    thumbnail: "https://i.ytimg.com/vi/5Eqb_-j3FDA/mqdefault.jpg",
    views: '110k',
    createdAt: '12 May 2022',
    src: 'https://www.youtube.com/watch?v=5Eqb_-j3FDA',
    category: 'music',
    duration: '5:58',
  },
  {
    _id: uuid(),
    title:"BROWN MUNDE (OFFICIAL VIDEO) AP DHILLON | GURINDER GILL | SHINDA KAHLON | GMINXR",
    description: "Latest Punjabi Song 2022\n\"BROWN MUNDE\" - AP DHILLON | GURINDER GILL | SHINDA KAHLON | GMINXR\n\nSong  Raj B Shetty, Bobby Simha and Danish Sait amongst others.",
    creator: "Shinda Kahlon",
    logo: "https://yt3.ggpht.com/DhVq3438WZYaIVF1nsWiR801dCOvfpUn_RkX0goc1FFH-1rzHW_mVl0R1oD1mTz8McdOlPT1Qg=s88-c-k-c0x00ffffff-no-nd-rj",
    thumbnail: "https://i.ytimg.com/vi/guw3URDiN8E/mqdefault.jpg",
    views: '5M',
    createdAt: '12 May 2022',
    src: 'https://www.youtube.com/watch?v=Hrzzm_YdMUA',
    category: 'music',
    duration: '6:58',
  },
  {
    _id: uuid(),
    title: "Bonding Video Song (Kannada) - 777 Charlie | Rakshit Shetty | Kiranraj K | Nobin Paul",
    description: "Here is the official song of the upcoming movie, a Paramvah Studios production, 777 Charlie starring Rakshit Shetty, Sangeetha Sringeri, Raj B Shetty, Bobby Simha and Danish Sait amongst others.",
    creator: "Paramvah Music",
    logo: "https://yt3.ggpht.com/ytc/AKedOLS_LbomBpZa_AT4_H3GTSads2wmv6IxaeBDyGhzGQ=s88-c-k-c0x00ffffff-no-rj",
    thumbnail: "https://i.ytimg.com/vi/Hrzzm_YdMUA/mqdefault.jpg",
    views: '5M',
    createdAt: '12 May 2022',
    src: 'https://www.youtube.com/watch?v=guw3URDiN8E',
    category: 'music',
    duration: '6:58',
  },
  {
    _id: uuid(),
    title: 'Mehabooba Video Song (Kannada) | KGF Chapter 2 | RockingStar Yash',
    description: 'Watch Mehabooba Full Video Song From KGF Chapter 2 Kannada Movie.\n\nSubscribe to our Youtube Channel : http://bit.ly/1hE4KpS\n\nBanner: Hombale Films\n\nWritten & Directed by: Prashanth Neel\nProduced by: Vijay Kiragandur\n\nStarring: Rocking Star Yash, Sanjay Dutt, Srinidhi Shetty, Raveena Tandon,Ananth Nag, Prakash Raj, Malvika Avinash, Achyuth Kumar',
    creator: 'Lahari Music | T-Series',
    logo: 'https://yt3.ggpht.com/Mhh_nJJXou1WSQp1SvBMGRpWXp2fk_oy_gU1yQWxEMYFMAEcaT2wJo7Fzl31rmBY79qQMkTaAA=s88-c-k-c0x00ffffff-no-rj',
    thumbnail: 'https://i.ytimg.com/vi/TNFXSKbQ3JA/mqdefault.jpg',
    views: '5M',
    createdAt: '12 May 2022',
    src: 'https://www.youtube.com/watch?v=TNFXSKbQ3JA',
    category: 'music',
    duration: '6:58',
  },
 {
   _id: uuid(),
   title: 'Ed Sheeran - Perfect (Official Music Video)',
   description: "The official music video for Ed Sheeran - Perfect \nThe new album \"=\" is out now - listen here: https://es.lnk.to/equals\n \nTaken from the studio album ÷ (divide) released in 2017, which featured the hit singles 'Castle on the Hill', 'Shape of You', 'Galway Girl', ‘Perfect’ & 'Happier'. \n \nSubscribe to the Ed Sheeran channel for all the best and latest official music videos",
   creator: 'Ed Shareen',
   logo: 'https://yt3.ggpht.com/-syoRcPPGt3NE3TzbKJsefa5Rej4w_lSof-aXSm1Q9cDx5Gyn-Cuus8UKjKBtILs_Bqwgc_i0A=s88-c-k-c0x00ffffff-no-nd-rj',
   thumbnail: 'https://i.ytimg.com/vi/2Vv-BfVoq4g/mqdefault.jpg',
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=2Vv-BfVoq4g',
   category: 'music',
   duration: '6:58',
 }, 
    //7 CODING
 {
   _id: uuid(),
   title: "Closures in JS 🔥 | Namaste JavaScript Episode 10",
   description: "Closures in JavaScript is the most important topic for interviews. Even many senior frontend developers don't understand this concept properly.  This video will clear all your doubts about closures in js and you will never have to find any other tutorial after this to understand function Closure and Garbage collection.",
   creator: 'Akshay Saini',
   logo: 'https://yt3.ggpht.com/ytc/AKedOLR8gqN3fHHNYbehMcsJ49rapBPhJMGPYSrl6YQyNg=s88-c-k-c0x00ffffff-no-rj',
   thumbnail: 'https://i.ytimg.com/vi/qikxEIxsXco/mqdefault.jpg',
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=qikxEIxsXco',
   category: 'coding',
   duration: '5:58',
 },//ddddddddddddddddddddd
 {
   _id: uuid(),
   title: "Mock React job interview (featuring Cassidy Williams)",
   description: "✨ Check out Cassidy's React interview questions course over at  Scrimba.com and nail your React interview: https://scrimba.com/learn/reactinterview?utm_source=youtube&utm_medium",
   creator: "Scrimba",
   logo: "https://yt3.ggpht.com/fim3ppqLo62mUlrsTDNvNcCzHKvIzVww1Nq-S71A56IMKeuHLzpCSSyOXaapHFhJNfEf__21=s88-c-k-c0x00ffffff-no-rj",
   thumbnail: "https://i.ytimg.com/vi/ZV373VaS4UM/mqdefault.jpg",
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=ZV373VaS4UM',
   category: 'coding',
   duration: '5:58',
 },
 {
   _id: uuid(),
   title: "Mock Junior Front End Web Developer Interview with Mike Chen and Silvia",
   description: "Mike (a former AirBnb Hiring Manager) interviews an aspiring Junior Web Developer to see if she's job ready. Will Mike \"hire\" her or must she continue to level-up? \n\n\n00:00",
   creator: "Scrimba",
   logo: "https://yt3.ggpht.com/fim3ppqLo62mUlrsTDNvNcCzHKvIzVww1Nq-S71A56IMKeuHLzpCSSyOXaapHFhJNfEf__21=s88-c-k-c0x00ffffff-no-rj",
   thumbnail: "https://i.ytimg.com/vi/j7CG7awlrQA/maxresdefault.jpg",
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=j7CG7awlrQA&t=3303s',
   category: 'coding',
   duration: '5:58',
 },
 {
   _id: uuid(),
   title: "Coding Interview with Dan Abramov",
   description: "#benawad #react ​\n​\n----\nFollow me online: https://voidpet.com/benawad\n#benawad",
   creator: "Ben Awad",
   logo: "https://yt3.ggpht.com/ytc/AKedOLScd3qE7Blu2CtRbzkfBzbEwE3_bIpO-dRaQjTPTg=s88-c-k-c0x00ffffff-no-rj",
   thumbnail: "https://i.ytimg.com/vi/XEt09iK8IXs/mqdefault.jpg",
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=XEt09iK8IXs',
   category: 'coding',
   duration: '5:58',
 },
 {
   _id: uuid(),
   title: "JavaScript Crash Course For Beginners",
   description: "In this crash course we will go over the fundamentals of JavaScript including more modern syntax like classes, arrow functions, etc.This is the starting point on my channel for learning JS.\n\ nCode including html / css: \nhttps: //embed.plnkr.co/plunk/8ujYdL1BxZftGoS4Cf14\n\n21 Hour JavaScript Course",
   creator: 'Traversy Media',
   logo: 'https://yt3.ggpht.com/ytc/AKedOLSxHOOxxa9Af8Bfb2XMop3lm4tor9bViWiC-d5aaw=s88-c-k-c0x00ffffff-no-rj',
   thumbnail: 'https://i.ytimg.com/vi/hdI2bqOjy3c/mqdefault.jpg',
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=hdI2bqOjy3c',
   category: 'coding',
   duration: '5:58',
 },
 {
   _id: uuid(),
   title: "5 Design Patterns Every Engineer Should Know",
   description: "In this video we will talk about some important software design patterns\n\nJack Herrington YouTube Channel:\nhttps://www.youtube.com/channel/UC6vRUjYqDuoUsYsku86Lrsw\n\nTimestamps:\n0:00 - Intro\n2:14 - Singleton Pattern\n3:51 - Facade Pattern\n5:48 - Bridge/Adapter Pattern\n8",
   creator: 'Traversy Media',
   logo: "https://yt3.ggpht.com/ytc/AKedOLSxHOOxxa9Af8Bfb2XMop3lm4tor9bViWiC-d5aaw=s88-c-k-c0x00ffffff-no-rj",
   thumbnail: "https://i.ytimg.com/vi/FLmBqI3IKMA/mqdefault.jpg",
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=FLmBqI3IKMA',
   category: 'coding',
   duration: '5:58',
 },
 {
   _id: uuid(),
   title: "Minimal to Canonical Form Conversion (Part 1)",
   description: "Digital Electronics: Minimal to Canonical Form Conversion (Part 1)\nTopics discussed:\n1) Minimal to canonical SOP form conversion.\n2) Minimal to canonical POS form conversion.",
   creator: 'Neso Academy',
   logo: 'https://yt3.ggpht.com/ytc/AKedOLS6ix06LgBU3BDeogUH0KQhblvxM6FV-kZvI_3R=s240-c-k-c0x00ffffff-no-rj',
   thumbnail: 'https://i.ytimg.com/vi/Km5pTz67uGc/mqdefault.jpg',
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://youtu.be/Km5pTz67uGc',
   category: 'coding',
   duration: '5:58',
 },
 {
   _id: uuid(),
   title: "JavaScript in the browser!",
   description: "Welcome to neogcamp. We have learned programming and web basics in previous lessons. This time we will use both things to create a dynamic app in a web browser. You'll learn about DOM scripting i.e. JS in the browser, calling servers, and getting data from there, taking user input and showing user output, and many more things.\n\nFor intermediate to advanced developers, if you already know how to do vanillaJS and do AJAX etc",
   creator: 'Tanay Pratap',
   logo: 'https://yt3.ggpht.com/ytc/AKedOLQnvobEXpzHCxB1g-q2aXbRDzSaznFVHo5OdFML=s88-c-k-c0x00ffffff-no-rj',
   thumbnail: 'https://i.ytimg.com/vi/yLZazznWoAs/mqdefault.jpg',
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=yLZazznWoAs',
   category: 'coding',
   duration: '5:58',
 },
 {
   _id: uuid(),
   title: "90% Cleaner React With Hooks - Ryan Florence - React Conf 2018",
   description: "Welcome to neogcamp. We have learned programming and web basics in previous lessons. This time we will use both things to create a dynamic app in a web browser. You'll learn about DOM scripting i.e. JS in the browser, calling servers, and getting data from there, taking user input and showing user output, and many more things.\n\nFor intermediate to advanced developers, if you already know how to do vanillaJS and do AJAX etc",
   creator: 'React Conf',
   logo: 'https://yt3.ggpht.com/ytc/AKedOLR3sZqbFv8RU7X_IEmG5Rfd0_-26qdWZJ8XbXr2jw=s88-c-k-c0x00ffffff-no-rj',
   thumbnail: 'https://i.ytimg.com/vi/wXLf18DsV-I/mqdefault.jpg',
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=wXLf18DsV-I',
   category: 'coding',
   duration: '5:58',
 },
 {
   _id: uuid(),
   title: "JavaScript Programming - Full Course",
   description: "Learn JavaScript from scratch by solving over a hundred different coding challenges. Go here for the interactive browser version: https://scrimba.com/learn/learnjavascript\n\n⭐️ Code ⭐️\nTwo versions:\n🔗 Interactive version",
   creator: 'freeCodeCamp',
   logo: 'https://yt3.ggpht.com/ytc/AKedOLRR2uNiXJiFH-XRmtGgkdICxTuDJxCPJidKFRNCNg=s88-c-k-c0x00ffffff-no-rj',
   thumbnail: 'https://i.ytimg.com/vi/jS4aFq5-91M/mqdefault.jpg',
   views: '110k',
   createdAt: '12 May 2022',
   src: 'https://www.youtube.com/watch?v=jS4aFq5-91M',
   category: 'coding',
   duration: '5:58',
 },

  // 3 NATURE
{
  _id: uuid(),
  title: "Switzerland in 8K ULTRA HD HDR - Heaven of Earth (60 FPS)",
  description: "Swiss town with lake and nice palm tree 6: 30\ n27.Geneva City with lake in Switzerland 7: 01\ n28.Farm with cows eating grass in the field 7: 22\ n29.Lucerne City in Switzerland 7: 35\ n30.Geneva City with green beautiful mountain in Switzerland 7: 51\ n31.Geneva City in Switzerland(part 2) 8: 04\ n32.Matterhorn with blue sky and clouds 8: 24\ n33.Green Tree and mountain with little river 8: 42\ n34.Narrow roads and cars are moving along the side of the hill 8: 54\ n35.Lucerne City in Switzerland 9: 18\ n36.red glacier express in Switzerland alps 9: 31\ n37.",
  creator: '8K World',
  logo: "https://yt3.ggpht.com/ytc/AKedOLSS1lyM1dY-UqjVb023wncf64ON14K9N6zQwSVH=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/linlz7-Pnvw/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=linlz7-Pnvw',
  category: 'nature',
  duration: '5:58',
},//dd
{
  _id: uuid(),
  title: "Home and Rain - This monsoon at our hometown | Karavali Karnataka | Steps Together",
  description: "Monsoon is always a gifted season for us coastal Karnataka people. This is our small effort to capture the beauty of the rain at our hometown Brahmavara and Aroor of Udupi district, Karnataka.\nIts our tribute to the beautiful nature which has given us everything to cherish",
  creator: "Steps Together",
  logo: "https://yt3.ggpht.com/ytc/AKedOLTBdBKq_5yxY1U_aLrWzQ683fHY42JPw1hqkoqLvQ=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/foiERISLZBs/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=foiERISLZBs',
  category: 'nature',
  duration: '5:58',
},
{
  _id: uuid(),
 "title": "DANDELI WILDLIFE- Karnataka One state Many World",
 description: "https://suggisampada.com/2021/09/29/kenara-circle/\nDandeli Wildlife Sanctuary is located at 15°30′23″N 74°23′30″E in Uttara Kannada District of Karnataka state in India. The sanctuary covers an area of 866.41 km2",
  creator: "ViWays",
  logo: "https://yt3.ggpht.com/ytc/AKedOLRDilpFqNXsUnmBdeDDC4oblfDW6eseOYXjkrO_rA=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/OsWcZnRPE6w/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=OsWcZnRPE6w',
  category: 'nature',
  duration: '5:58',
},
{
  _id: uuid(),
  title: "Experience Nagarahole at Home",
  description: "On the occasion of World Environment Day, Karnataka Forest Department Presents \n“Experience Nagarahole at Home”.\n\nFilmed & Edited By\nPrakash Matada\nAdditional Filming\nAnil Narahari, Bharath Kumar V, Gopi R K, Naveen Rowth, Pradhyum Kashyap, Raju K V",
  creator: 'Nagarahole Tiger Conservation Foundation',
  logo: "https://yt3.ggpht.com/ytc/AKedOLREc8qqaeRMzHeqN4vJw_ngLGlSbh_eBOjEJvI8qw=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: 'https://i.ytimg.com/vi/LL_0B4m4WXs/mqdefault.jpg',
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=LL_0B4m4WXs',
  category: 'nature',
  duration: '5:58',
},
{
  _id: uuid(),
  title: "Men of The Mist – conserving Kudremukh National Park",
  description: "Kudremukh - A place that most people will recognize as a mining center, from where iron ore was extracted. Today, however, this mining has been extracted from this biodiversity hotspot restoring the region to becoming one of India's most spectacular and biologically rich tropical rainforest landscapes.",
  creator: "Dilan Mandanna",
  logo: "https://yt3.ggpht.com/ytc/AKedOLRYnx4kUQXK6SlZ5hjPBs--YubK3ywdJQuiPN7j7w=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/VFYT3VrbZdk/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=VFYT3VrbZdk',
  category: 'nature',
  duration: '5:58',
},
{
  _id: uuid(),
  title: "Chinese online star Li Ziqi provides an escape from urban life",
  description: "Subscribe to our YouTube channel for free here: \nhttps://sc.mp/subscribe-youtube\n\nChinese online star Li Ziqi has become one of the most famous internet celebrities in the country by sharing videos of her rural life. She picks ingredients from her farm, constructs furniture by hand and cooks a vast spread, providing a respite from busy urban living for her tens of millions of fans worldwide.\n\nFollow us on:\nWebsite:  https://scmp.com\nFacebook",
  creator: 'South China Morning Post',
  logo: "https://yt3.ggpht.com/ytc/AKedOLR5u-P-n-9CDMgBsxorfnZH41bdvP13qnXcpnsDTg=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/r6z_ia0L7Wc/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=r6z_ia0L7Wc',
  category: 'nature',
  duration: '5:58',
},
{
  _id: uuid(),
  title: "Gooey sweet potatoes &hand-made noodles",
  description: "Liziqi channel—— roast sweet potato and  spicy and sour noodles\n烤红薯的香甜和酸辣粉的鲜辣，暖冬好滋味\n\n挖了红薯做够大半年要用的淀粉，\n再囤一点宽粉 细苕粉应付这个冬季。\n冰雪天，来上一碗麻辣鲜香的手工酸辣粉\n饭后再整俩又香又甜的烤红薯。\n一边在雪地里蹦跶一边吐着烤红薯的热气！\n呼…………\n\nNewly dug-out sweet potatoes, enough to make starch for half a year’s use.\nMake some into noodles wide or thin, and stock up for the winter.\nIn snowy days, have a bowl of such hand-made noodles, in hot and sour soup.\nAnd roast two more gooey sweet potatoes.\nOh, I can see my sweet hot breath in the snow.\nHot! hu h",
  creator: 'Liziqi',
  logo: "https://yt3.ggpht.com/ytc/AKedOLSIVX8gVv9IlIO5u3qSueSEB4C_zgqCxy66BEdq0A=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/yMRiUPzp0RY/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=yMRiUPzp0RY',
  category: 'nature',
  duration: '5:58',
},

// HEALTH
{
  _id: uuid(),
  title: "Back Pain Relief Exercises & Stretches - Ask Doctor Jo",
  description: "These back pain stretches and exercises are for general back pain like soreness from overworking your back or if you've pulled a muscle. If you know your specific back pain diagnosis, can check out the back pain section of my website for more specific exercises and stretches. See Doctor Jo’s blog post about this at: http://www.askdoctorjo.com/how-to-relieve-back-pain\n\nThe first stretch is called the pelvic tilt.",
  creator: "AskDoctorJo",
  logo: "https://yt3.ggpht.com/ytc/AKedOLRDiw-1RdxiPuE5f1FPqOgRqw2AUAApg3OKTaMH=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/2VuLBYrgG94/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=2VuLBYrgG94',
  category: 'health',
  duration: '5:58',
},
{
  _id: uuid(),
  title: "Healthy Tips For Programmers & Web Developers",
  description: "In this video we will touch on healthy lifestyle tips for computer programmers, web developers and anyone else who sits down all day and stares at a computer screen. \n\nVISIT US:\nhttp://www.traversymedia.com\n\nEDUONIX COURSES: Pleas use affiliate links from website below\nhttp://www.traversymedia.com/eduonix-courses\n\nSUPPORT: We spend massive amounts of time creating these free videos, please donate to show your support:\nhttp://www.patreon.com/traversymedia\nhttp://www.paypal.me/traversymedia\n\nFOLLOW TRAVERSY MEDIA:\nhttp://www.facebook.com/traversymedia\nhttp://www.twitter.com/traversymedia\nhttp://www.linkedin.com/bradtraversy",
  creator: "Traversy Media",
  logo: "https://yt3.ggpht.com/ytc/AKedOLSxHOOxxa9Af8Bfb2XMop3lm4tor9bViWiC-d5aaw=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/_CDKp0CJ0mw/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=_CDKp0CJ0mw',
  category: 'health',
  duration: '5:58',
},
// SHORT MOVIEW
{
  _id: uuid(),
  title: "Cubicles - EP 01 - Access Denied",
  description: "Piyush is super excited for his first day at Synnotech Technologies. He believes that in order to ensure that this new chapter in his life is a memorable one, it is imperative to have a great first day. However, he finds out that it might not be in his control! \r\n\nStream Music from the Show: https://smarturl.it/CubiclesS1Music\n\nThis is an investor education and awareness initiative by DSP Mutual",
  creator: "The Viral Fever",
  logo: "https://yt3.ggpht.com/ytc/AKedOLSMKxpcCRD_mO-B01VxY5JUSpoDYLDzrPL_2jSe5w=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/JbBsqmKclXE/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=JbBsqmKclXE',
  category: 'short moview',
  duration: '5:58',
},
{
  _id: uuid(),
  title: "TVF's Aspirants | Episode 1 | UPSC - Optional Me Kya Hai?",
  description: "Rate us on IMDb - https://www.imdb.com/title/tt14392248/\n\nAs a UPSC Aspirant, choices are always tough when you have to select the subjects.",
  creator: "The Viral Fever",
  logo: "https://yt3.ggpht.com/ytc/AKedOLSMKxpcCRD_mO-B01VxY5JUSpoDYLDzrPL_2jSe5w=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/0Kl1ucZuSZ8/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=0Kl1ucZuSZ8',
  category: 'short moview',
  duration: '5:58',
},
{
  _id: uuid(),
  "title": "AWARD Winning Hindi Short Film - ZUNI (The Untold Truth of Every Family) Ft. Divya Dutta | BB Films",
  "description": "As relatable as it can get there's a Zuni that resides in all of us. In the rush of things, pressure at work & due to social life stigma we often skip the ground to be more emotive.",
  creator: "Big Bat Films",
  logo: "https://yt3.ggpht.com/ltuXayiyT5d3WHTx4E3Zy3FvyhxpYAmYaaETScjrf1ruxlZv5jr_G_1c_yGUEBPj-gzMKenfxQ=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/1NAX6ilB8xY/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src:'hhtps://www.youtube.com/watch?v=1NAX6ilB8xY',
  category: 'short moview',
  duration: '5:58',
},
{
  _id: uuid(),
  "title": "You Changed Me - Inspirational Short Film | Hindi",
  "description": "It is said that if you want to change a man's mind, change the mind of the man, next to him first. You changed me is the story of a mid-aged, well-educated man, who lost himself in the daily chores of life. It is also a reflection of how someone's vibes and life influence other's life.\n\nAwards & Festivals:\n11th Dada Saheb Phalke Film Festival – 21",
  creator: "Pocket Films - Indian Short Films",
  logo: "https://yt3.ggpht.com/ryRkzIaFK7aM1sLPCbdSRNtzOnPNSTiP1XNP0Y2wzIrqcLYVxhldAq63sWw8s4Tmm3MnV8h22w=s88-c-k-c0x00ffffff-no-rj",
  thumbnail: "https://i.ytimg.com/vi/srBQcPV4zbU/mqdefault.jpg",
  views: '110k',
  createdAt: '12 May 2022',
  src: 'https://www.youtube.com/watch?v=srBQcPV4zbU',
  category: 'short moview',
  duration: '5:58',
},


];
